'use client';

/**
 * When true, the receipt renders the ReceiptMango watermark regardless of the
 * template's own showWatermark setting. The builder preview wraps its canvas
 * with this for non-Pro users, so both the live preview and the DOM-captured
 * exports carry the watermark. Defaults to false so template-picker thumbnails
 * and admin previews stay clean.
 */
import { createContext, useContext } from 'react';

export const WatermarkRequiredContext = createContext(false);

export function useWatermarkRequired(): boolean {
  return useContext(WatermarkRequiredContext);
}
